import React, { useMemo } from "react";
import styled from "styled-components";
import {
  useStoryblokEditable,
  StoryblokComponent
} from "@sb-konzept/gatsby-source-storyblok";
import Image from "gatsby-image";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";

export const SuperlinkContext = React.createContext();

function BannerStory(props) {
  const editableProps = useStoryblokEditable();
  const { content, superLink } = props;
  const {
    body,
    layout,
    image,
    imageAltText,
    imageOverflow,
    buttonLabel,
    action,
    backgroundColor,
    spacingY
  } = content;

  return (
    <Box
      position="relative"
      bgcolor={backgroundColor}
      display="flex"
      my={`${spacingY}%` || 0}
    >
      {image.localFile &&
        (imageOverflow ? (
          <Hidden mdDown>
            <Box
              position="absolute"
              top="-25%"
              bottom="-25%"
              right="8.33vw"
              width="50%"
              zIndex={3000}
            >
              <Image
                {...editableProps}
                fluid={image.localFile?.childImageSharp.fluid}
                style={{ position: "absolute", width: "100%", height: "100%" }}
                imgStyle={{
                  objectFit: "scale-down",
                  objectPosition: "right center"
                }}
                alt={imageAltText || "image"}
              />
            </Box>
          </Hidden>
        ) : (
          <Box flex={1}>
            <Image
              fluid={image.localFile?.childImageSharp.fluid}
              alt={imageAltText || "image"}
            />
          </Box>
        ))}

      {body && body.length >= 1 && (
        <SuperlinkContext.Provider value={{ exists: !!superLink, superLink }}>
          <Box flex={1} flexDirection="column">
            {body?.map(content => (
              <StoryblokComponent
                key={content._uid || content.id}
                content={content}
              />
            ))}
          </Box>
        </SuperlinkContext.Provider>
      )}
    </Box>
  );
}

export default BannerStory;
